import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {InsightsPeriod} from '../../../../domain/insights-period';
import {IonicModule} from '@ionic/angular';
import {TenorSelectorComponent} from '../tenor-selector/tenor-selector.component';

@Component({
  selector: 'app-tenor-bar',
  imports: [IonicModule, TenorSelectorComponent],
  templateUrl: './tenor-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./tenor-bar.component.scss']
})
export class TenorBarComponent {
  @Input() availableTenors: InsightsPeriod[];
  @Input() activeTenor: InsightsPeriod;
  @Output() readonly changeActiveTenor: EventEmitter<InsightsPeriod> = new EventEmitter<InsightsPeriod>();

  onTenorSelect(tenor: InsightsPeriod): void {
    this.changeActiveTenor.emit(tenor);
  }
}
